import useFetchAllCategories from './useFetchAllCategories';

export default function useGetCategoryData(category) {
  const { allCategories } = useFetchAllCategories();

  const getCategoryData = (paramCategory) => {
    const catObject = allCategories[paramCategory?.toUpperCase()];

    return {
      categoryDbName: catObject?.categoryDbName || '',
      categoryName: catObject?.categoryName || '',
      categoryNameShort: catObject?.categoryNameShort || '',
      categoryUrl: catObject?.slugi18n || '',
      categoryHasGuide: catObject?.hasGuide || false,
      tier: catObject?.tier,
    };
  };

  return {
    getCategoryData,
    ...(category ? getCategoryData(category) : {}),
  };
}
